// Support description component for the support page.

import ApiUtils from '@shared/utils/api';
import Text from '@components/atoms/text/supportText';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { useMemo } from 'react';
import SupportDescriptionContainer from '@components/atoms/container/supportDescriptionContainer';

const LITERALS = 'PAGES.SETTINGS.SUPPORT';

/**
 * Support description component for the support page.
 * Displays the description paragraphs and the closing advice.
 *
 * @returns {JSX.Element} Support description component
 */
export default function SupportDescription() {
  const { advice, top, bottom } = useMemo(() => {
    return {
      top: TranslationManager.get(`${LITERALS}.DESCRIPTION.TOP`),
      bottom: TranslationManager.get(
        `${LITERALS}.DESCRIPTION.BOTTOM`,
        ApiUtils.getUrl('support_contact')
      ),
      advice: TranslationManager.get(`${LITERALS}.ADVICE`),
    };
  }, []);

  return (
    <>
      <SupportDescriptionContainer>
        <Text>{top}</Text>
        <Text dangerouslySetInnerHTML={{ __html: bottom }} />
      </SupportDescriptionContainer>
      <Text>{advice}</Text>
    </>
  );
}
